/**
 * 用户组弹窗选择插件
 * @Author duo
 * @date 2020-01-03
 */
import React from 'react';
import { connect } from 'dva';
import { component_tool, framework_tool, utils_tool } from '@/tool';
import { modelUtils } from "../../../../utils";

let { WizContainer } = framework_tool;
let { WizTag, WizTableTransfer,WizTooltip } = component_tool;
let { $$,checkStrLength } = utils_tool;
/**
 * 左边表格columns
 */
const leftTableColumns = [
  {
    dataIndex: 'title',
    title: '名称',
    width:100,
    ellipsis:true,
    render: (text) => <WizTooltip title={text} placement="topLeft" >{text}</WizTooltip>,
  },
  {
    dataIndex: 'code',
    title: '编码',
    width:100,
    ellipsis:true,
    render: (text) => <WizTooltip title={text} placement="topLeft" >{text}</WizTooltip>,
  },
  {
    dataIndex: 'remark',
    title: '备注',
    width:100,
    ellipsis:true,
    render: (text) => <WizTooltip title={text} placement="topLeft" >{text}</WizTooltip>,
  }
];

/**
 * 右边表格columns
 */
const rightTableColumns = [
  {
    dataIndex: 'title',
    title: '名称',
    width:100,
    ellipsis:true,
    render: (text) => <WizTooltip title={text} placement="topLeft" >{text}</WizTooltip>,
  },
  {
    dataIndex: 'code',
    title: '编码',
    width:100,
    ellipsis:true,
    render: (text) => <WizTooltip title={text} placement="topLeft" >{text}</WizTooltip>,
  }
];

class UserGroupSelect extends WizContainer {

  componentName = 'UserGroupSelect';

  constructor(props) {
    super(props);
    this.state = {
      targetKeys: [],
      personId: props.record && props.record.personId
    }
    this.initTargetKeys = []
  }

  static defaultProps = {
    _ok: this._doGroupUserAdd,
  };

  /**
   * 初始化已选角色
   */
  _doInitParams = () => {
    this.onChange(this.initTargetKeys)
  }

  /**
   * 用户组新增用户
   */
  _doGroupUserAdd = () => {
    const { personId, targetKeys } = this.state;
    if (!this.state.targetKeys || ($$.isArray(this.state.targetKeys) && !(this.state.targetKeys).length)) {
      wizNotice.warn("请先选择用户组");
    } else if (this.props.record.personId) {
      this.doAction({
        path: "groupUserManagement/addGroupUserByUser",
        payload: {
          key: "groupUserAddKey",
          apiParams: {
            "personId": personId,
            "groupIds": targetKeys
          }
        }
      });
    } else {
      wizNotice.warn("请先选择用户");
    }
  };

  onChange = nextTargetKeys => {
    this.setState({ targetKeys: nextTargetKeys });
  };

  _componentDidMount = () => {
    this._getData();
    this._getUserGroupData();
  };

  propsAndStateOnChange = {
    groupUserList: this._setTargetKeys.bind(this),
    groupUserAddResult: this._setGroupAddState.bind(this)
  };

  /**
   * 得到已有的数据key即groupId
   * @param nextProps
   * @param nextState
   * @returns {boolean}
   * @private
   */
  _setTargetKeys(nextProps, nextState) {
    let targetIds = [];
    nextProps.groupUserList.data.forEach(data => {
      targetIds.push(data.groupId)
    });
    nextState.targetKeys = targetIds;
    this.initTargetKeys = targetIds
    return true;
  }

  /**
   * 保存后返回提示
   * @param nextProps
   * @param nextState
   * @private
   */
  _setGroupAddState(nextProps, nextState) {
    if (nextProps.groupUserAddResult.code === 1) {
      this.initTargetKeys = this.state['targetKeys']
      wizNotice.success("操作成功");
      this.props.changeModal(false);
    } else {
      wizNotice.error(nextProps.groupUserAddResult.msg);
    }

  }

  /**
   * 查询用户组列表
   * @private
   */
  _getData() {
    this.doAction({
      path: "groupManagement/queryGroupList",
      payload: {
        key: "groupGetListByConditionKey",
        apiParams: {}
      }
    });
  }

  /**
   * 查询用户所属用户组
   * @private
   */
  _getUserGroupData() {
    this.doAction({
      path: "groupUserManagement/queryGroupUserList",
      payload: {
        key: "userGroupGetListByConditionKey@" + this.props.record.personId,
        apiParams: {
          "personId": this.props.record.personId
        }
      }
    });
  }


  _render() {
    const { targetKeys } = this.state;
    let listData = this.props.groupList.data ? this.props.groupList.data : [];
    const mockData = [];
    let returnView = null;
    if (listData && listData.length) {
      listData.forEach(groupData => {
        mockData.push({
          key: groupData.id,
          title: groupData.name,
          code: groupData.code,
          remark: groupData.remark,
          disabled: false,
        })
      }
      );
    }
    returnView = <WizTableTransfer
      key={this.props.record.personId}
      dataSource={mockData}
      targetKeys={targetKeys}
      onChange={this.onChange}
      filterOption={(inputValue, item) =>
        item.title.indexOf(inputValue) !== -1 || item.code.indexOf(inputValue) !== -1 || item.remark.indexOf(inputValue) !== -1
      }
      leftColumns={leftTableColumns}
      rightColumns={rightTableColumns}
    />

    return returnView;
  }
}

const mapStateToProps = (state, ownProps) => {
  const { groupManagement,groupUserManagement} = state;
  const groupList = modelUtils.getModelEntity(groupManagement, "groupGetListByConditionKey");
  const groupUserList = modelUtils.getModelEntity(groupUserManagement, "userGroupGetListByConditionKey@" + ownProps.record.personId);
  const groupUserAddResult = modelUtils.getModelEntity(groupUserManagement, "groupUserAddKey");

  return {
    groupList: groupList,
    groupUserList: groupUserList,
    groupUserAddResult: groupUserAddResult
  }
};

const options = { withRef: true };

export default connect(mapStateToProps, null, null, options)(UserGroupSelect);

